class companiesController{
  constructor(
    $companies,
    CONFIG
  ){
    'ngInject';
    $companies.setUri( CONFIG.API.companies );
    $companies.init().then( () => this.ready = true);
  }
}

export default companiesController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies.controller.js
 **/